import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'get'

export default class OspreyAccountSearch extends BaseAction {
    constructor(dataKey) {
        const id = 'ffb92b92-82b3-40ea-a150-25e514edfa6b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'id,name,status,gsmId,created,modified,siloCount,city,state'
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-search.js